import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import ic_pin from "../../../../../../assets/IconProvider/ic_pin.svg";
import ic_notes from "../../../../../../assets/IconProvider/ic_notes.svg";
import emails from "../../../../../../assets/IconProvider/email.svg";
import ic_notesx from "../../../../../../assets/IconProvider/ic_notesx.svg";
import { Set_DropOff_Inputs, Set_latlng, Set_Pickup_Inputs, ChooseoOnMapimg, SetopenAddressBookInNewOrder, Edit_Travel_set_pickup, Edit_Travel_set_Dropoff_inputs } from "../../../../../../Redux/actions/actionNames";
import note from "../../../../../../assets/ic-note-for-driver.svg";
import email from "../../../../../../assets/ic_person.svg";
import { getCenterMap, setCenterMap } from "../../../../../../helper/module";
import styles from './style.module.css';
import IconProvider from "../../../../../../design-system/lib/IconProvider";
import { ADDRESS_BOOK, ARROW_DOWN_BOLD, IC_address_book } from "../../../../../../assets";
import Typography from "../../../../../../design-system/lib/Typography";
import Tag from "../../../../../../design-system/lib/Tag";
import Button from "../../../../../../design-system/lib/Button";



var _ = require("lodash");

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false
    };
    this.anchorEl = React.createRef();
  }

  showPoper = () => {
    this.setState({ showpoper: true });
  };

  setAddressToPD = () => {

    setCenterMap(this.props.mapRef, { lng: this.props.AddressData.coordinates[0], lat: this.props.AddressData.coordinates[1] })

    try {
      getCenterMap(this.props.mapRef, { lng: this.props.AddressData.coordinates[0], lat: this.props.AddressData.coordinates[1] })
      this.props.dispatch(
        Set_latlng({
          lng: this.props.AddressData.coordinates[0],
          lat: this.props.AddressData.coordinates[1],
        })
      );
      // this.props.mapRef.current.leafletElement.setView({lng: this.props.AddressData.coordinates[0], lat: this.props.AddressData.coordinates[1]}, 17);
    } catch (error) {
      this.props.dispatch(
        Set_latlng({
          lng: this.props.AddressData.coordinates[0],
          lat: this.props.AddressData.coordinates[1],
        })
      );
    }

    if (this.props.sourceOfAddressBookInNewOrder.type == "dropoff") {
      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "adresss_loc",
          value: { lng: this.props.AddressData.coordinates[0], lat: this.props.AddressData.coordinates[1] },
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );


      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "address",
          value: this.props.AddressData.address,
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );


      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "block",
          value: this.props.AddressData.buildingBlock,
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );


      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "floor",
          value: this.props.AddressData.floor,
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );

      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "recieverFullName",
          value: this.props.AddressData.fullName,
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );


      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "unit",
          value: this.props.AddressData.room,
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );

      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "recieverPhoneNumber",
          value: (this.props.AddressData.phone && this.props.AddressData.phone.length > 0) ? (String(this.props.AddressData.phone).startsWith("00") ?
            "+" + String(this.props.AddressData.phone).slice(2, this.props.AddressData.phone.length) : String(this.props.AddressData.phone)) : "",
            firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
            id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );


      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "noteForDriver",
          value: this.props.AddressData.description,
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );



      this.props.dispatch(
        Edit_Travel_set_Dropoff_inputs({
          name: "email",
          value: this.props.AddressData.email,
          firstDropOff: this.props.sourceOfAddressBookInNewOrder.first,
          id: this.props.sourceOfAddressBookInNewOrder.id,
        })
      );





    } else {

      this.props.dispatch(
        Edit_Travel_set_pickup({
          adresss_loc: { lng: this.props.AddressData.coordinates[0], lat: this.props.AddressData.coordinates[1] },
          address: this.props.AddressData.address,
          block: this.props.AddressData.buildingBlock,
          floor: this.props.AddressData.floor,
          senderFullName: this.props.AddressData.fullName,
          senderPhoneNumber: (this.props.AddressData.phone && this.props.AddressData.phone.length > 0) ? (String(this.props.AddressData.phone).startsWith("00") ?
            "+" + String(this.props.AddressData.phone).slice(2, this.props.AddressData.phone.length) : String(this.props.AddressData.phone)) : "",
          unit: this.props.AddressData.room,
          noteForDriver: this.props.AddressData.description,
          email: this.props.AddressData.email,
        })


      );



    }
    this.props.dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));

  };


  getBlockFloorRoom = () => {
    if (this.props.AddressData.buildingBlock.length > 0 || this.props.AddressData.room.length > 0 || this.props.AddressData.floor.length > 0) {
      let arr = [];
      this.props.AddressData.buildingBlock.length > 0 && arr.push(`${this.props.t("block")} ${this.props.AddressData.buildingBlock}`)
      this.props.AddressData.room.length > 0 && arr.push(`${this.props.t("Unit")} ${this.props.AddressData.room}`)
      this.props.AddressData.floor.length > 0 && arr.push(`${this.props.t("Floor")} ${this.props.AddressData.floor}`)


      return arr.join(" , ")
    } else {
      return false
    }
  }

  getNamePhone = () => {
    if (this.props.AddressData.phone.length > 0 || this.props.AddressData.fullName.length > 0) {

      let arr = [];

      this.props.AddressData.phone.length > 0 && arr.push(this.props.AddressData.phone)
      this.props.AddressData.fullName.length > 0 && arr.push(this.props.AddressData.fullName)

      return arr.join(" , ")
    } else {
      return false
    }
  }


  getNote = () => {
    if (
      this.props.AddressData.description.length > 0
    ) {
      return this.props.AddressData.description
    } else {
      return false;
    }
  };


  getEmail = () => {
    if (
      this.props.AddressData.email.length > 0
    ) {
      return this.props.AddressData.email
    } else {
      return false;
    }
  };



  render() {
    return (
      <div className={styles.addressItemMenuContainer} >

        <div className={styles.frow}>
          <div className={styles.innerFrow} onClick={this.setAddressToPD}>

            <IconProvider Icon={IC_address_book} />
            <Typography text={this.props.AddressData.title} weight="Body_Middle_Bold" />
            {(this.props.AddressData.isDefaultPickupAddress) && <Tag text="Default pickup" size="Medium" backgroundColor="GrayUltraLight" weight="Body_Small_Regular" style={{ marginInlineStart: "4px" }} />
            }
          </div>

          {(this.getNamePhone() && this.getEmail() && this.getNote()) && <Button size="Medium" type="Secondary" icon={ARROW_DOWN_BOLD} style={{ transform: "scale(.7)", marginInlineStart: "auto" }} onClick={() => { this.setState({ collapse: !this.state.collapse }) }} />
          }        </div>

        <div className={styles.row} onClick={this.setAddressToPD}>
          <IconProvider Icon={ic_pin} />
          <div className={styles.rowTexts}>
            <Typography text={this.props.AddressData.address} weight="Body_Tiny_Regular" style={{ color: "#484848" }} />
            {this.getBlockFloorRoom() && <Typography text={this.getBlockFloorRoom()} weight="Body_Tiny_Regular" style={{ color: "#808080" }} />}
          </div>

        </div>

        {(this.getNamePhone() && this.state.collapse) && <div className={styles.row} onClick={this.setAddressToPD}>
          <IconProvider Icon={ic_notes} />
          <div className={styles.rowTexts}>
            {this.props.AddressData.fullName.length > 0 && <Typography text={this.props.AddressData.fullName} weight="Body_Tiny_Regular" style={{ color: "#484848" }} />}
            {this.props.AddressData.phone.length > 0 && <Typography text={this.props.AddressData.phone} weight="Body_Tiny_Regular" style={{ color: "#808080" }} />}
          </div>

        </div>}

        {(this.getEmail() && this.state.collapse) && <div className={styles.row} onClick={this.setAddressToPD}>
          <IconProvider Icon={emails} />
          <div className={styles.rowTexts}>
            <Typography text={this.getEmail()} weight="Body_Tiny_Regular" style={{ color: "#484848" }} />
          </div>

        </div>}


        {(this.getNote() && this.state.collapse) && <div className={styles.row} onClick={this.setAddressToPD}>
          <IconProvider Icon={ic_notesx} />
          <div className={styles.rowTexts}>
            <Typography text={this.getNote()} weight="Body_Tiny_Regular" style={{ color: "#484848" }} />
          </div>

        </div>}

        {/* <span className="admcT"> {this.props.AddressData.title}</span>
       {(this.props.AddressData.isDefaultPickupAddress) && <span className="admcDFP"> Default pickup</span>}
        <div className="admcI">
          <img src={add1} />
          <span> {this.props.AddressData.address}</span>
        </div>

        {this.getBlockFloorRoom() && <div className="admcI">
          <img src={add2} />
          <span> {this.getBlockFloorRoom()}</span>
        </div>}

       {this.getNamePhone() && <div className="admcI">
          <img src={add3} />
          <span> {this.getNamePhone()}</span>
        </div>}

        {this.getNote() && (
          <div className="admcI">
            <img src={note} />
            <span> {this.getNote()}</span>
          </div>
        )}

      {this.getEmail() && (
          <div className="admcI">
            <img src={email} />
            <span> {this.getEmail()}</span>
          </div>
        )} */}

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mapRef: state.Map.mapRef,
  center: state.Map.center,
  sourceOfAddressBookInNewOrder:
    state.Addressbook.sourceOfAddressBookInNewOrder,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
